/**
 * @file 登录ip检验
 * @auth alfielv
 */

import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Dialog } from '@tencent/spaui';
import { message } from '@tencent/ptp-fe-common';
import { connect } from 'react-redux';
import { hasFeatureFlag } from '@/services';
import { smb_fetch } from '@/api/operator/fetch';
import { logout } from '@/pages/agency/utils/logout.js';
import useLoginReport from './useLoginReport';

import './index.less';

// 校验实名验证状态间隔
const CHECK_VERIFY_STATUS_DURATION = 3000;

// 获取登录态，异常会返回二维码
export const checkLogin = () => {
  const url = '/agp/agms/v1/login/check';
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    {
      data: {},
    },
  );
  return smb_fetch<any>(url, params, false, false);
};

/**
 * 获取用户认证结果
 */
export const getVerifyStatus = () => {
  const url = '/agp/agms/v1/login/verify_status/get';
  const params = $.extend(
    true,
    {
      method: 'post',
    },
    {
      data: {},
    },
  );
  return smb_fetch<any>(url, params);
};

const agencyLoginUrl = 'https://sso.e.qq.com/frontend/login?sso_redirect_uri=https%3A%2F%2Fe.qq.com%2Fads%2F&service_tag=46';

const IPExceptionCheck = () => {
  // 展示ip exception
  const [showIPExceptionCheck, setShowIPExceptionCheck] = useState(false);
  const [showDisabledStatus, setShowDisabledStatus] = useState(false);
  // qrcode
  const [qrcode, setQrcode] = useState('');

  // 获取扫码认证结果
  const timerRef = useRef<NodeJS.Timer | null>(null);

  // 判断是否需要扫码认证
  const handleCheckRST = useCallback(async () => {
    try {
      const { code, data, message: errorMessage, msg, ret } = await checkLogin();
      if (code === 0) {
        const { check_rst, qrcode } = data || {};
        // check_rst不为0，意为IP校验失败，展示二维码进行认证
        if (check_rst !== 0) {
          setShowIPExceptionCheck(true);
          setQrcode(qrcode);
        }
        return;
      }

      // code  11003 表示封禁
      // if (code === 11003) {
      //   setShowDisabledStatus(true);
      //   return;
      // }

      throw new Error(errorMessage || msg);
    } catch (error) {
      message.strongwarn(error.message);
    }
  }, []);
  // 获取扫码认证状态
  const handleVerifyStatusCheck = useCallback(async () => {
    timerRef.current && clearTimeout(timerRef.current);
    try {
      const { code, data, message: errorMessage } = await getVerifyStatus();
      if (code === 0) {
        const { verify_rst } = data || {};

        // 0:未验证;1:验证通过;2:验证失败-验证通过可取消弹窗
        if (verify_rst === 1) {
          message.success('用户验证通过');
          setShowIPExceptionCheck(false);
        } else {
          timerRef.current = setTimeout(() => {
            handleVerifyStatusCheck();
          }, CHECK_VERIFY_STATUS_DURATION);
        }

        return;
      }
      throw new Error(errorMessage);
    } catch (error) {
      message.strongwarn(error.message);
    }
  }, []);

  useEffect(() => {
    handleCheckRST();
  }, []);

  useEffect(() => {
    // ip校验通过，不轮询check认证状态
    if (!showIPExceptionCheck) {
      return;
    }
    // ip校验未通过，轮询check认证状态
    handleVerifyStatusCheck();
  }, [showIPExceptionCheck]);

  return (
    <>
      <Dialog
        className="face-verify__dialog-content"
        useNewUI
        show={showIPExceptionCheck}
        closeButton={false}
        title='人脸认证'
        subTitle="为了保障您的账号安全，请进行登录验证"
        backdrop={true}
        enabledBackdropClose={false}
        hideFooter={true}
        contentStyle={{ width: '600px', height: '400px' }}
        hideHeaderDivider={true}
      >
        <p className="face-verify__dialog-content__title">使用手机“微信扫一扫”扫码验证</p>
        <div className="face-verify__dialog-content__qrcode">
          {qrcode ? <img src={`data:image/png;base64,${qrcode}`} /> : <div className="face-verify__dialog-content__qrcode__failed">二维码获取失败</div>}
        </div>
        <div className="face-verify__dialog-content__desc">
          <p>二维码1分钟内有效有效，过期请 <span className="text-link" onClick={handleCheckRST}>刷新</span></p>
        </div>
      </Dialog>

      <Dialog
        className="face-verify__dialog-content"
        useNewUI
        show={showDisabledStatus}
        closeButton={false}
        title='登录提醒'
        backdrop={false}
        enabledBackdropClose={false}
        hideFooter={false}
        cancelButton={false}
        onSubmit={() => {
          logout(agencyLoginUrl);
          setShowDisabledStatus(false);
        }}
        hideHeaderDivider={true}
      >
        <p>您好，系统识别到您因违规操作账号已被封禁，如有疑问请咨询服务商管理员</p>
      </Dialog>
    </>
  );
};


const IPExceptionCheckWrapper = (props: any) => {
  useLoginReport();

  // 灰度范围内，进行LBS校验
  if (hasFeatureFlag('is_login_ip_exception_enable')) {
    return <IPExceptionCheck {...props} />;
  }
  return null;
};


function mapStateToProps(state: { loginStatus: any; }) {
  const loginStatus = state.loginStatus;
  return {
    loginStatus,
  };
}

export default connect(mapStateToProps)(IPExceptionCheckWrapper);
